var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPipedrive = function SvgPipedrive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_7895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#017737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7786 13.3354C24.7786 17.6642 21.9855 20.6249 17.9918 20.6249C16.0932 20.6249 14.5285 19.8425 13.9427 18.8649L13.9704 19.8702V26.0699H9.89353V10.0397C9.89353 9.81669 9.8381 9.76 9.58613 9.76H8.18896V6.35338H11.5968C13.1603 6.35338 13.5521 7.69386 13.663 8.28094C14.2778 7.24787 15.8967 6.04724 18.1871 6.04724C22.1253 6.04598 24.7786 8.97764 24.7786 13.3354ZM20.6173 13.3631C20.6173 11.045 19.1093 9.45386 17.2094 9.45386C15.646 9.45386 13.886 10.4869 13.886 13.3921C13.886 15.2907 14.9468 17.2737 17.154 17.2737C18.7742 17.2724 20.6173 16.0995 20.6173 13.3631Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_7895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPipedrive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pipedrive.9d9e02f8e442e77daf8ee823566f017c.svg";